import { createContext, useContext, useEffect, useState } from "react";
import { API, DEFAULT_CONTENT, mergeContent } from "@/lib/site";

const ContentContext = createContext(DEFAULT_CONTENT);

export function ContentProvider({ children }) {
  const [content, setContent] = useState(DEFAULT_CONTENT);

  useEffect(() => {
    let alive = true;
    fetch(`${API}/content`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (alive && d) setContent(mergeContent(d));
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);

  return <ContentContext.Provider value={content}>{children}</ContentContext.Provider>;
}

export function useContent() {
  return useContext(ContentContext);
}
